import LoadingComponent from './Loading'

const HeaderMobileDropdownAsync = () => ({
  // The component to load (should be a Promise)
  component: import(/* webpackChunkName: "mobile-group" */ './HeaderMobileDropdown.vue'),
  // A component to use while the async component is loading
  loading: LoadingComponent,
  // A component to use if the load fails
  // Delay before showing the loading component. Default: 200ms.
  delay: 20,
  // The error component will be displayed if a timeout is
  // provided and exceeded. Default: Infinity.
})

export {HeaderMobileDropdownAsync}
